"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimDocumentType = void 0;
var ClaimDocumentType;
(function (ClaimDocumentType) {
    ClaimDocumentType["AppraisalReports"] = "01";
    ClaimDocumentType["ReportsOrInspections"] = "02";
    ClaimDocumentType["Quotes"] = "03";
    ClaimDocumentType["Invoices"] = "04";
    ClaimDocumentType["UnderwritingDocumentation"] = "05";
    ClaimDocumentType["InsuranceSettlementDocumentation"] = "06";
    ClaimDocumentType["JudgementDocumentation"] = "07";
    ClaimDocumentType["BankruptcyDocumentation"] = "08";
    ClaimDocumentType["TitleDocumentation"] = "09";
    ClaimDocumentType["CreditReport"] = "10";
    ClaimDocumentType["SettlementInLieuOfJudgement"] = "11";
    ClaimDocumentType["StatementOfAdjustment"] = "12";
    ClaimDocumentType["Miscellaneous"] = "13";
})(ClaimDocumentType = exports.ClaimDocumentType || (exports.ClaimDocumentType = {}));
